/* SessionLastUpdated.tsx generated by @compiled/babel-plugin v3.0.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D");
import React, { type ReactNode } from 'react';
import { Box } from '@atlaskit/primitives/compiled';
const styles = {
  lastUpdated: "_3YEZNOdnbC _1ANEUSLRg7"
};
export type SessionLastUpdatedProps = {
  lastUpdated: ReactNode;
  testId?: string;
};

/** Renders display-ready localized relative session time. */
export const SessionLastUpdated = ({
  lastUpdated,
  testId
}: SessionLastUpdatedProps): React.JSX.Element | null => {
  if (lastUpdated === undefined || lastUpdated === null || lastUpdated === false) {
    return null;
  }
  return <Box as="span" xcss={styles.lastUpdated} testId={testId}>
			{lastUpdated}
		</Box>;
};